import React, { Component } from 'react';
import {
    Route,
    Switch
} from 'react-router-dom';
import Breadcrumb from './ui/Breadcrumb.js'
import Store from './Store.js'
import Overview from './Overview.js'
import Index from './Index.js'
import Descriptor from './Descriptor.js'
import ProtobufBreadcrumb from './ProtobufBreadcrumb.js'

class Reference extends Component {
    render() {
        let store = new Store();
        let rootBreadcrumbItem = {
            name: "Happy API",
            link: this.props.match.path
        };
        return (
            <div>
                <Switch>
                    <Route exact path={`${this.props.match.path}`} render={(obj) => (
                        <Breadcrumb items={[rootBreadcrumbItem]} />
                    )} />
                    <Route exact path={`${this.props.match.path}/index`} render={(obj) => (
                        <Breadcrumb items={[rootBreadcrumbItem]} />
                    )} />
                    <Route path={`${this.props.match.path}/:fullyQualifiedName`} render={(obj) => {
                        let fullyQualifiedName = obj.match.params.fullyQualifiedName;
                        return (
                            <ProtobufBreadcrumb rootItem={rootBreadcrumbItem} fullyQualifiedName={fullyQualifiedName} />
                        );
                    }} />
                </Switch>
                <div className="container mt-5">
                    <Switch>
                        <Route exact path={`${this.props.match.path}`} render={(obj) => (
                            <Overview store={store} baseUrl={obj.match.url}/>
                        )} />
                        <Route exact path={`${this.props.match.path}/index`} render={(obj) => (
                            <Index store={store} baseUrl={obj.match.url}/>
                        )} />
                        <Route path={`${this.props.match.path}/:fullyQualifiedName`} render={(obj) => {
                            let fullyQualifiedName = obj.match.params.fullyQualifiedName;
                            return (
                                <Descriptor descriptor={store.descriptor(fullyQualifiedName)} />
                            );
                        }} />
                    </Switch>
                </div>
            </div>
        );
    }
}

export default Reference;



// WEBPACK FOOTER //
// ./src/reference/Reference.js